export const HEADER_CONTENT_DISPOSITION = 'content-disposition';
export const FILE_NAME = 'filename=';
